import React, {Component} from 'react';

export default class Tabs extends Component {
	constructor(props) {
		super();
		const {default_tab = 0} = props;
		this.state = {
			current_tab: default_tab
		};
	}

	switchTab(tab) {
		this.setState({
			current_tab: tab
		});
	}

	validateTab() {
		const {tabs = []} = this.props;
		let {current_tab} = this.state;

		if (tabs[current_tab]) {
			return;
		}

		while (current_tab > 0 && !tabs[current_tab]) {
			current_tab--;
		}

		if (tabs[current_tab]) {
			this.switchTab(current_tab);
		} else if (current_tab !== 0) {
			this.switchTab(0);
		}
	}

	componentDidMount() {
		this.validateTab();
	}

	componentDidUpdate() {
		this.validateTab();
	}

	render() {
		const {current_tab} = this.state;
		const {tabs = [], ...props} = this.props;

		if (tabs.length === 0) {
			return null;
		}

		const content = tabs[current_tab] && tabs[current_tab].content;

		return (
			<div {...props}>
				<ul className='tabs'>
					{tabs.map((tab, idx) => (
						<li key={idx} className={idx === current_tab ? 'selected' : null}
							onClick={e => this.switchTab(idx)}>
							<a href={tab.link}>{tab.label}</a>
						</li>
					))}
				</ul>
				{content && (
					<div key={tabs.length * current_tab} className='tab-content'>
						<div className='block custom-mt-24'>
							{content}
						</div>
					</div>
				)}
			</div>
		);
	}
}